<template>
    <ion-app>
        <SideMenu />
        <ion-router-outlet id="main-content" />
    </ion-app>
</template>

<script setup lang="ts">
import { IonApp, IonRouterOutlet } from "@ionic/vue";
import SideMenu from "@/components/SideMenu.vue";
</script>
